import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Header from '../../components/ui/Header';
import MobileNav from '../../components/ui/MobileNav';
import QuickActions from '../../components/ui/QuickActions';
import ProfileHeader from './components/ProfileHeader';
import SocialStats from './components/SocialStats';
import AudienceDemographics from './components/AudienceDemographics';
import PortfolioGallery from './components/PortfolioGallery';
import PricingTable from './components/PricingTable';
import ReviewsSection from './components/ReviewsSection';
import ProposalModal from './components/ProposalModal';
import MessageModal from './components/MessageModal';
import { useAuth } from '../../contexts/AuthContext';

const InfluencerProfile = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [isProposalModalOpen, setIsProposalModalOpen] = useState(false);
  const [isMessageModalOpen, setIsMessageModalOpen] = useState(false);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [userRole] = useState('artist');
  const { user, openLoginModal } = useAuth();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const influencerData = {
    name: "Ayşe Yılmaz",
    username: "ayse_music_vibes",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1400f5ad7-1763296600804.png",
    avatarAlt: "Professional headshot of Turkish woman with long dark hair wearing elegant black blazer and warm smile",
    coverImage: "https://images.unsplash.com/photo-1575812459029-6c8225481451",
    coverImageAlt: "Modern music studio setup with professional equipment, colorful LED lights, and acoustic panels on walls",
    verified: true,
    rating: 4.8,
    reviewCount: 201,
    engagementRate: 8.5,
    bio: "Müzik tutkunu content creator. Pop, R&B ve elektronik müzik üzerine içerikler üretiyorum. 5 yıldır sosyal medyada aktif olarak müzik tanıtımları yapıyorum ve sanatçılarla işbirliği geliştiriyorum.",
    categories: ["Pop Müzik", "R&B", "Elektronik", "Müzik Tanıtımı", "Playlist Küratörlüğü"]
  };

  const socialPlatforms = [
  {
    name: "instagram",
    handle: "ayse_music_vibes",
    followers: 285000
  },
  {
    name: "tiktok",
    handle: "aysemusic",
    followers: 420000
  },
  {
    name: "youtube",
    handle: "AyseMusicVibes",
    followers: 156000
  },
  {
    name: "spotify",
    handle: "Ayşe\'s Picks",
    followers: 89000
  }];


  const demographics = {
    ageGroups: [
    { range: "18-24", percentage: 45 },
    { range: "25-34", percentage: 35 },
    { range: "35-44", percentage: 15 },
    { range: "45+", percentage: 5 }],

    gender: [
    { type: "Kadın", percentage: 62 },
    { type: "Erkek", percentage: 38 }],

    locations: [
    { city: "İstanbul", percentage: 38 },
    { city: "Ankara", percentage: 18 },
    { city: "İzmir", percentage: 15 },
    { city: "Antalya", percentage: 12 },
    { city: "Diğer", percentage: 17 }]

  };

  const portfolio = [
  {
    id: 1,
    type: "Video",
    title: "Yeni Single Tanıtımı - Sertab Erener",
    thumbnail: "https://images.unsplash.com/flagged/photo-1572372983589-b12727fc8df7",
    thumbnailAlt: "Female singer performing on stage with dramatic purple and blue stage lighting and microphone",
    views: 450000,
    likes: 38500,
    comments: 2100,
    date: "15 Kasım 2025",
    description: "Sertab Erener\'in yeni single\'ı için hazırladığım tanıtım videosu. Video 48 saat içinde 450K görüntüleme aldı ve %8.5 etkileşim oranına ulaştı."
  },
  {
    id: 2,
    type: "Reels",
    title: "Playlist Önerisi - Yaz Hitleri",
    thumbnail: "https://images.unsplash.com/photo-1630250497284-737c32e032f1",
    thumbnailAlt: "Young woman with headphones dancing joyfully outdoors in summer sunlight with urban background",
    views: 680000,
    likes: 52000,
    comments: 3400,
    date: "08 Kasım 2025",
    description: "Yaz aylarının en popüler şarkılarını içeren playlist tanıtımı. Viral oldu ve 680K görüntüleme aldı."
  },
  {
    id: 3,
    type: "Story",
    title: "Backstage - Konser Hazırlığı",
    thumbnail: "https://images.unsplash.com/photo-1615659718520-caa02e809c54",
    thumbnailAlt: "Behind the scenes concert preparation showing stage crew setting up equipment and lighting systems",
    views: 125000,
    likes: 18500,
    comments: 890,
    date: "02 Kasım 2025",
    description: "Konser öncesi backstage hikayesi. Takipçilerimle özel anları paylaştım."
  },
  {
    id: 4,
    type: "Post",
    title: "Albüm İncelemesi - Kenan Doğulu",
    thumbnail: "https://images.unsplash.com/photo-1629426957074-a50d0b927ba2",
    thumbnailAlt: "Vinyl record player with colorful album covers displayed on wooden shelf in modern music room",
    views: 320000,
    likes: 28000,
    comments: 1650,
    date: "28 Ekim 2025",
    description: "Kenan Doğulu\'nun yeni albümü hakkında detaylı inceleme ve öneriler."
  },
  {
    id: 5,
    type: "Video",
    title: "Müzik Prodüksiyonu Süreci",
    thumbnail: "https://images.unsplash.com/photo-1625017134591-7b7db7bcd640",
    thumbnailAlt: "Music producer working at digital audio workstation with multiple monitors and MIDI keyboard in professional studio",
    views: 280000,
    likes: 24500,
    comments: 1320,
    date: "20 Ekim 2025",
    description: "Stüdyoda müzik yapım sürecini anlattığım eğitici içerik."
  },
  {
    id: 6,
    type: "Reels",
    title: "Trending Şarkı Challenge",
    thumbnail: "https://images.unsplash.com/photo-1716743705197-fe047da139c7",
    thumbnailAlt: "Group of young people dancing energetically to music in colorful urban street setting with graffiti walls",
    views: 890000,
    likes: 76000,
    comments: 4200,
    date: "12 Ekim 2025",
    description: "Viral olan şarkı challenge\'ına katılım. Platform genelinde trend oldu."
  }];


  const pricingPackages = [
  {
    id: "story",
    name: "Story Paketi",
    description: "Instagram story paylaşımı",
    price: 2500,
    deliveryTime: 2,
    icon: "Image",
    popular: false,
    features: [
    "1 adet Instagram story",
    "24 saat yayında kalma",
    "Swipe-up linki",
    "Hashtag optimizasyonu",
    "Performans raporu"]

  },
  {
    id: "post",
    name: "Post Paketi",
    description: "Feed gönderisi ve story",
    price: 5000,
    deliveryTime: 3,
    icon: "Grid",
    popular: true,
    features: [
    "1 adet feed gönderisi",
    "2 adet story paylaşımı",
    "Profesyonel fotoğraf çekimi",
    "Caption yazımı",
    "Hashtag stratejisi",
    "Detaylı performans raporu"]

  },
  {
    id: "video",
    name: "Video Paketi",
    description: "Reels/TikTok video içeriği",
    price: 8500,
    deliveryTime: 5,
    icon: "Video",
    popular: false,
    features: [
    "1 adet Reels/TikTok videosu",
    "Profesyonel video prodüksiyonu",
    "Müzik entegrasyonu",
    "3 adet story paylaşımı",
    "Cross-platform paylaşım",
    "Kapsamlı analiz raporu"]

  }];


  const reviews = [
  {
    id: 1,
    name: "Mehmet Kaya",
    role: "Bağımsız Sanatçı",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_15656800d-1763295667113.png",
    avatarAlt: "Professional headshot of Turkish man with short dark hair and beard wearing casual denim jacket",
    rating: 5,
    comment: "Ayşe ile çalışmak harikaydı! Single\'ımın tanıtımını çok profesyonel bir şekilde yaptı. Etkileşim oranları beklentilerimin çok üzerinde çıktı. Kesinlikle tekrar çalışacağım.",
    campaign: "Single Tanıtımı - \'Yaz Gecesi'",
    date: "2025-11-20",
    verified: true
  },
  {
    id: 2,
    name: "Zeynep Demir",
    role: "Müzik Prodüktörü",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_158ebe045-1763294644032.png",
    avatarAlt: "Professional portrait of Turkish woman with long brown hair wearing elegant black turtleneck sweater",
    rating: 5,
    comment: "Çok detaylı ve özenli bir çalışma. Müziğimizi hedef kitleye ulaştırmada çok başarılı oldu. İletişimi mükemmel, teslimatlar zamanında. Herkese tavsiye ederim.",
    campaign: "EP Lansmanı",
    date: "2025-11-15",
    verified: true
  },
  {
    id: 3,
    name: "Can Yıldız",
    role: "Plak Şirketi Yöneticisi",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_15656800d-1763295667113.png",
    avatarAlt: "Business portrait of Turkish man with styled hair wearing formal navy blue suit and tie",
    rating: 4,
    comment: "Profesyonel yaklaşımı ve içerik kalitesi çok iyi. Sadece teslimat süresi biraz uzadı ama sonuç mükemmeldi. Tekrar çalışmayı düşünüyoruz.",
    campaign: "Albüm Tanıtım Kampanyası",
    date: "2025-11-08",
    verified: true
  },
  {
    id: 4,
    name: "Elif Şahin",
    role: "Vokal Koçu & Sanatçı",
    avatar: "https://images.unsplash.com/photo-1708789353477-794bd17363ab",
    avatarAlt: "Artistic portrait of Turkish woman with curly hair wearing bohemian style clothing and statement jewelry",
    rating: 5,
    comment: "Ayşe'nin takipçi kitlesi tam bizim hedef kitlemizle uyuşuyor. Kampanya sonrası Spotify dinlenme sayılarımız %300 arttı. Harika bir deneyimdi!",
    campaign: "Yeni Single Lansmanı",
    date: "2025-10-28",
    verified: true
  },
  {
    id: 5,
    name: "Burak Özkan",
    role: "DJ & Prodüktör",
    avatar: "https://images.unsplash.com/photo-1726597394681-3b55591d8f2a",
    avatarAlt: "Cool portrait of Turkish DJ with trendy hairstyle wearing black leather jacket and sunglasses",
    rating: 5,
    comment: "Elektronik müzik alanında çok bilgili ve deneyimli. Remix\'imin tanıtımını çok etkili bir şekilde yaptı. Sonuçlar beklentilerimin çok üzerinde çıktı.",
    campaign: "Remix Tanıtımı",
    date: "2025-10-22",
    verified: true
  }];


  const handleSelectPackage = (pkg) => {
    if (!user) {
      openLoginModal();
      return;
    }
    setSelectedPackage(pkg);
    setIsProposalModalOpen(true);
  };

  const handleMessageClick = () => {
    if (!user) {
      openLoginModal();
      return;
    }
    setIsMessageModalOpen(true);
  };

  const handleProposalClick = () => {
    if (!user) {
      openLoginModal();
      return;
    }
    setIsProposalModalOpen(true);
  };

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="pt-16 pb-20 md:pb-6">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="mb-6">
            <button
              onClick={() => navigate(-1)}
              className="inline-flex items-center gap-2 text-muted-foreground hover:text-foreground transition-smooth">

              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M19 12H5M12 19l-7-7 7-7" />
              </svg>
              <span className="text-sm font-medium">Geri Dön</span>
            </button>
          </div>

          <div className="space-y-6">
            <ProfileHeader
              influencer={influencerData}
              onMessageClick={handleMessageClick}
              onProposalClick={handleProposalClick} />


            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
              <div className="lg:col-span-1 space-y-6">
                <SocialStats platforms={socialPlatforms} />
                <AudienceDemographics demographics={demographics} />
              </div>

              <div className="lg:col-span-2 space-y-6">
                <PortfolioGallery portfolio={portfolio} />
                <PricingTable packages={pricingPackages} onSelectPackage={handleSelectPackage} />
                <ReviewsSection
                  reviews={reviews}
                  averageRating={influencerData?.rating}
                  totalReviews={influencerData?.reviewCount} />

              </div>
            </div>
          </div>
        </div>
      </main>
      <MobileNav userRole={userRole} />
      <QuickActions userRole={userRole} />
      <ProposalModal
        isOpen={isProposalModalOpen}
        onClose={() => {
          setIsProposalModalOpen(false);
          setSelectedPackage(null);
        }}
        influencerName={influencerData?.name}
        selectedPackage={selectedPackage} />

      <MessageModal
        isOpen={isMessageModalOpen}
        onClose={() => setIsMessageModalOpen(false)}
        influencerName={influencerData?.name} />

    </div>);

};

export default InfluencerProfile;